import { StarIcon } from "@heroicons/react/24/solid"
import React, { useEffect, useState } from "react"

import { ScrollRevealItem } from "../../WebsiteBuilderV2/components/shared/ScrollReveal"

import HeroSearchBar from "./HeroSearchBar"

const HeroLandingSection = ({ isMobile = false, initialLocation }) => {
  const [location, setLocation] = useState("")
  const [latLng, setLatLng] = useState(null)

  useEffect(() => {
    const onNewLocationChosen = (e) => {
      const newLocation = e.detail
      setLocation(newLocation)
      sessionStorage.setItem("cityState", newLocation)
      document.dispatchEvent(new CustomEvent("homepageLocationUpdated", { detail: newLocation }))
    }
    const onNewLocationCoordinates = (e) => {
      if (e.detail && Array.isArray(e.detail) && e.detail.length === 2) {
        setLatLng(e.detail)
        sessionStorage.setItem("latlng", JSON.stringify(e.detail))
      }
    }

    document.addEventListener("newLocationChosen", onNewLocationChosen)
    document.addEventListener("newLocationCoordinates", onNewLocationCoordinates)

    return () => {
      document.removeEventListener("newLocationChosen", onNewLocationChosen)
      document.removeEventListener("newLocationCoordinates", onNewLocationCoordinates)
    }
  }, [])

  useEffect(() => {
    const getUserLocation = () => {
      if (typeof window === "undefined" || typeof sessionStorage === "undefined") return

      if (initialLocation?.cityState) {
        setLocation(initialLocation.cityState)
        if (initialLocation.latlng && Array.isArray(initialLocation.latlng) && initialLocation.latlng.length === 2) {
          setLatLng(initialLocation.latlng)
          sessionStorage.setItem("latlng", JSON.stringify(initialLocation.latlng))
        }
        sessionStorage.setItem("cityState", initialLocation.cityState)
        document.dispatchEvent(new CustomEvent("homepageLocationUpdated", { detail: initialLocation.cityState }))
        return
      }

      const storedLatLng = sessionStorage.getItem("latlng")
      if (storedLatLng) {
        try {
          const parsed = JSON.parse(storedLatLng)
          if (Array.isArray(parsed) && parsed.length === 2) setLatLng(parsed)
        } catch (e) {
          const parsed = storedLatLng.split(",").map(Number)
          if (parsed.length === 2 && !isNaN(parsed[0]) && !isNaN(parsed[1])) setLatLng(parsed)
        }
      }

      if (sessionStorage.getItem("cityState")) {
        const savedLocation = sessionStorage.getItem("cityState")
        setLocation(savedLocation)
        document.dispatchEvent(new CustomEvent("homepageLocationUpdated", { detail: savedLocation }))
        return
      }

      setLocation("97703")
      document.dispatchEvent(new CustomEvent("homepageLocationUpdated", { detail: "97703" }))
    }

    getUserLocation()
  }, [initialLocation])

  const handleSearch = ({ query, location: searchLocation }) => {
    if (query?.trim() || searchLocation?.trim()) {
      const params = new URLSearchParams()
      if (query?.trim()) params.set("query", query)
      if (searchLocation?.trim()) params.set("searched_location", searchLocation)
      if (latLng && Array.isArray(latLng) && latLng.length === 2) {
        params.set("mapCenter", `${latLng[0]},${latLng[1]}`)
        // Keep legacy keys for older search clients / bookmarks
        params.set("aroundLatLng[lat]", latLng[0].toString())
        params.set("aroundLatLng[lng]", latLng[1].toString())
      }
      window.location.href = `/practitioner-search?${params.toString()}`
    }
  }

  return (
    <section className="relative flex items-center justify-center">
      <div className={`container relative z-10 mx-auto ${isMobile ? "w-full px-6" : "max-w-[1400px] px-10"}`}>
        <div className={`flex flex-col items-center ${isMobile ? "gap-4" : "gap-6"}`}>
          <ScrollRevealItem entranceDelayMs={320} variant="fadeUp" threshold={0} className="text-center">
            <h2
              className="text-center text-builder-primary"
              style={{
                fontFamily: '"Source Serif 4", serif',
                fontSize: isMobile ? "36px" : "40px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: isMobile ? "44px" : "48px",
                fontFeatureSettings: "'liga' off, 'clig' off"
              }}>
              Discover <span style={{ color: "#0d9da4" }}>trusted</span>
              {isMobile && <br />} wellness practitioners
            </h2>
          </ScrollRevealItem>

          <ScrollRevealItem entranceDelayMs={580} variant="fadeUp" threshold={0} className="flex w-full justify-center">
            <HeroSearchBar location={location} onSearch={handleSearch} isMobile={isMobile} />
          </ScrollRevealItem>

          <ScrollRevealItem
            entranceDelayMs={780}
            variant="fadeUp"
            threshold={0}
            className="flex flex-wrap items-center justify-center text-center"
            style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "14px",
              fontWeight: 700,
              lineHeight: "20px",
              color: "#0B3954"
            }}>
            {isMobile ? (
              <>
                <span>100+ services</span>
                <span className="mx-2" style={{ color: "#55778a" }}>
                  &bull;
                </span>
                <span>4,000+ practitioners</span>
                <div className="w-full" />
                <span className="inline-flex items-center gap-1">
                  <StarIcon className="shrink-0 text-[#F4B965]" style={{ width: 14, height: 14 }} />
                  25,000+ client reviews
                </span>
              </>
            ) : (
              <>
                <span>100+ services</span>
                <span className="mx-2" style={{ color: "#55778a" }}>
                  &bull;
                </span>
                <span>4,000+ practitioners</span>
                <span className="mx-2" style={{ color: "#55778a" }}>
                  &bull;
                </span>
                <span className="inline-flex items-center gap-1">
                  <StarIcon className="shrink-0 text-[#F4B965]" style={{ width: 14, height: 14 }} />
                  25,000+ client reviews
                </span>
              </>
            )}
          </ScrollRevealItem>
        </div>
      </div>
    </section>
  )
}

export default HeroLandingSection
